import { chevronLeft } from './chevronLeft';

export const chevronUp = () => chevronLeft({
  transform: 'rotate(90 4 6)',
});
